var pug = require("!../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (view) {pug_html = pug_html + "\u003Cdiv class=\"device-type-multipliers form-horizontal\"\u003E";
// iterate view.listOfTypes
;(function(){
  var $$obj = view.listOfTypes;
  if ('number' == typeof $$obj.length) {
      for (var type = 0, $$l = $$obj.length; type < $$l; type++) {
        var i18nKey = $$obj[type];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("data-ref", type.toLowerCase() + '-bid-multiplier', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var type in $$obj) {
      $$l++;
      var i18nKey = $$obj[type];
pug_html = pug_html + "\u003Cdiv" + (pug.attr("data-ref", type.toLowerCase() + '-bid-multiplier', true, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return pug_html;};
module.exports = template;